module.exports = __webpack_public_path__ + "static/media/stock_in.ff336ffe.svg";